export default "__VITE_ASSET__BxXfcEwB__"